import { render, staticRenderFns } from "./CourseTransferCreate.vue?vue&type=template&id=e32bb54a&scoped=true"
import script from "./CourseTransferCreate.vue?vue&type=script&lang=js"
export * from "./CourseTransferCreate.vue?vue&type=script&lang=js"
import style0 from "./CourseTransferCreate.vue?vue&type=style&index=0&id=e32bb54a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32bb54a",
  null
  
)

export default component.exports